import styled from "styled-components";

export const Container = styled.div`
  padding: 16px;
`;

export const PropertyList = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
`;
export const PropertyItem = styled.div`
  display: flex;
  align-items: center;
  max-width: 150px;
  * {
    cursor: pointer;
  }
`;

export const StyledButton = styled.button`
  margin-top: 8px;
  padding: 4px;
`;
